import GATSBY_COMPILED_MDX from "/home/runner/work/pennylane.ai-react/pennylane.ai-react/apps/datasets/content/conventional-datasets-for-qml/index.mdx";
import React, {useState, useMemo} from 'react';
global.React = React;
import {withPrefix} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import {useCheckBanner} from 'shared-utilities';
import Seo from '../../components/seo';
import LinkComponent from '../../components/LinkComponent/LinkComponent';
import './style.scss';
import RelatedCarousel from '../../components/RelatedCarousel/RelatedCarousel';
import {jsx as _jsx} from "react/jsx-runtime";
import {jsxs as _jsxs} from "react/jsx-runtime";
import {Fragment as _Fragment} from "react/jsx-runtime";
const shortcodes = {
  a: LinkComponent
};
function MarkdownPageTemplate(_ref) {
  let {data, children} = _ref;
  const {mdx} = data;
  const frontmatter = (mdx === null || mdx === void 0 ? void 0 : mdx.frontmatter) || null;
  const {0: isBannerPresent, 1: setIsBannerPresent} = useState(false);
  const relatedItems = useMemo(() => {
    var _frontmatter$relatedC, _frontmatter$relatedC2;
    return frontmatter !== null && frontmatter !== void 0 && (_frontmatter$relatedC = frontmatter.relatedContent) !== null && _frontmatter$relatedC !== void 0 && _frontmatter$relatedC.length ? frontmatter === null || frontmatter === void 0 ? void 0 : (_frontmatter$relatedC2 = frontmatter.relatedContent) === null || _frontmatter$relatedC2 === void 0 ? void 0 : _frontmatter$relatedC2.map(filteredContent => {
      return {
        label: (filteredContent === null || filteredContent === void 0 ? void 0 : filteredContent.label) || '',
        link: (filteredContent === null || filteredContent === void 0 ? void 0 : filteredContent.link) || '',
        image: (filteredContent === null || filteredContent === void 0 ? void 0 : filteredContent.image) || ''
      };
    }) : [];
  }, [frontmatter === null || frontmatter === void 0 ? void 0 : frontmatter.relatedContent]);
  useCheckBanner(setIsBannerPresent);
  return _jsxs(_Fragment, {
    children: [_jsxs("ol", {
      className: "MarkdownPage__breadcrumb " + (isBannerPresent ? 'MarkdownPage__breadcrumb--bannerPresent' : ''),
      children: [_jsxs("li", {
        children: [_jsx(LinkComponent, {
          href: withPrefix('/'),
          className: "text-brand-blue-4",
          children: "Quantum Datasets"
        }), _jsx("span", {
          className: "MarkdownPage__breadcrumbSeparator",
          children: "/"
        })]
      }), (frontmatter === null || frontmatter === void 0 ? void 0 : frontmatter.title) && _jsx("li", {
        children: frontmatter.title
      })]
    }), _jsxs("div", {
      className: "MarkdownPage",
      children: [(frontmatter === null || frontmatter === void 0 ? void 0 : frontmatter.title) && _jsx("h1", {
        children: frontmatter.title
      }), _jsx(MDXProvider, {
        components: shortcodes,
        children: children
      })]
    }), relatedItems && relatedItems.length && _jsx("div", {
      className: "RelatedContainer",
      children: _jsx(RelatedCarousel, {
        relatedItems: relatedItems,
        title: "Related content"
      })
    })]
  });
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(MarkdownPageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref2 => {
  let {data} = _ref2;
  return _jsx(Seo, {
    title: data.mdx.frontmatter.meta_title ? data.mdx.frontmatter.meta_title : data.mdx.frontmatter.title,
    image: data.mdx.frontmatter.meta_image,
    description: data.mdx.frontmatter.meta_description,
    pathname: "/" + data.mdx.frontmatter.slug
  });
};
const pageQuery = "1485337250";
